const o=0,t=1,c=2,e=0,n=1;export{e as SCROLLBAR_VISIBILITY_SHOW_ALWAYS,n as SCROLLBAR_VISIBILITY_SHOW_WHEN_REQUIRED,t as SCROLL_MODE_BOUNCE,o as SCROLL_MODE_CLAMP,c as SCROLL_MODE_INFINITE};
